var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AppLayout',[_c('UserPanel',{staticClass:"user-profile-page px-0",attrs:{"slot":"main-content"},slot:"main-content"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }